import AccessibilityNewRounded from '@mui/icons-material/AccessibilityNewRounded'
import ArticleRounded from '@mui/icons-material/ArticleRounded'
import AssignmentRounded from '@mui/icons-material/AssignmentRounded'
import ChecklistRounded from '@mui/icons-material/ChecklistRounded'
import DrawRounded from '@mui/icons-material/DrawRounded'
import EventRounded from '@mui/icons-material/EventRounded'
import ForwardToInboxRounded from '@mui/icons-material/ForwardToInboxRounded'
import HistoryEduRounded from '@mui/icons-material/HistoryEduRounded'
import LockRounded from '@mui/icons-material/LockRounded'
import MedicalInformationRounded from '@mui/icons-material/MedicalInformationRounded'
import MedicationRounded from '@mui/icons-material/MedicationRounded'
import MonitorHeartRounded from '@mui/icons-material/MonitorHeartRounded'
import NotesRounded from '@mui/icons-material/NotesRounded'
import PaymentsRounded from '@mui/icons-material/PaymentsRounded'
import PsychologyRounded from '@mui/icons-material/PsychologyRounded'
import RecommendRounded from '@mui/icons-material/RecommendRounded'
import ScienceRounded from '@mui/icons-material/ScienceRounded'
import SelfImprovementRounded from '@mui/icons-material/SelfImprovementRounded'
import ShowChartRounded from '@mui/icons-material/ShowChartRounded'
import SickRounded from '@mui/icons-material/SickRounded'
import TipsAndUpdatesRounded from '@mui/icons-material/TipsAndUpdatesRounded'
import VisibilityRounded from '@mui/icons-material/VisibilityRounded'
import { EMR_SECTION_IDS, getCanonicalEmrSectionStyleOverrideKey } from './emrSectionIds'

// Client-side icon per EMR section (kept here rather than in the DB/server: icons are pure
// presentation, the section set is known, and this needs no backend/data migration).
const EMR_SECTION_ICON_BY_ID = {
  [EMR_SECTION_IDS.HEALTH_COMPLAINTS]: SickRounded,
  [EMR_SECTION_IDS.DIAGNOSIS]: MedicalInformationRounded,
  [EMR_SECTION_IDS.OBSERVATIONS]: VisibilityRounded,
  [EMR_SECTION_IDS.DRUG_ADVICE]: MedicationRounded,
  [EMR_SECTION_IDS.INVESTIGATIONS]: ScienceRounded,
  [EMR_SECTION_IDS.ADVICE]: TipsAndUpdatesRounded,
  [EMR_SECTION_IDS.NEXT_VISIT_DETAILS]: EventRounded,
  [EMR_SECTION_IDS.THERAPY_RECOMMENDATION]: SelfImprovementRounded,
  [EMR_SECTION_IDS.PAYMENT_AND_REFUND]: PaymentsRounded,
  [EMR_SECTION_IDS.JOINT_HOMUNCULUS]: AccessibilityNewRounded,
  [EMR_SECTION_IDS.INSTRUCTIONS]: ChecklistRounded,
  [EMR_SECTION_IDS.PATIENT_VITALS]: MonitorHeartRounded,
  [EMR_SECTION_IDS.SCREENING_REPORT]: AssignmentRounded,
  [EMR_SECTION_IDS.PRIVATE_NOTES]: LockRounded,
  [EMR_SECTION_IDS.PSYCH_ASSESSMENTS]: PsychologyRounded,
  [EMR_SECTION_IDS.REFER_TO]: ForwardToInboxRounded,
  [EMR_SECTION_IDS.PATIENT_HISTORY_NOTES]: HistoryEduRounded,
  [EMR_SECTION_IDS.SCREENING_RECOMMENDATION]: RecommendRounded,
  [EMR_SECTION_IDS.SIGNATURE]: DrawRounded,
  [EMR_SECTION_IDS.FREE_FORM_RICH_TEXT]: NotesRounded,
}

// Title-keyword fallbacks for sections that aren't fixed EMR ids (e.g. custom "Growth Chart
// Indicators", "Symptoms"), so they still get a meaningful icon.
function iconFromTitle(title) {
  const t = (title || '').toLowerCase()
  if (t.includes('growth') || t.includes('chart')) return ShowChartRounded
  if (t.includes('symptom')) return SickRounded
  if (t.includes('vital')) return MonitorHeartRounded
  if (t.includes('assess')) return PsychologyRounded
  if (t.includes('therap')) return SelfImprovementRounded
  if (t.includes('instruction')) return ChecklistRounded
  if (t.includes('advice')) return TipsAndUpdatesRounded
  if (t.includes('investigat') || t.includes('lab') || t.includes('test')) return ScienceRounded
  return null
}

/** MUI icon element for an EMR section (by canonical id, then title keyword, then a generic fallback). */
export function getEmrSectionIcon(emrSection, props = {}) {
  const canonicalId = getCanonicalEmrSectionStyleOverrideKey(emrSection)
  const Icon =
    EMR_SECTION_ICON_BY_ID[canonicalId] ||
    EMR_SECTION_ICON_BY_ID[emrSection?.id] ||
    iconFromTitle(emrSection?.title) ||
    ArticleRounded
  return <Icon fontSize="small" {...props} />
}
